import axios, { AxiosError } from 'axios';
import { useAuthStore } from '@/stores/auth';

export const api = axios.create({
  baseURL: '/api',
  timeout: 30000, // 30 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as any;
    const isAuthRequest = originalRequest?.url?.startsWith('/auth/');

    // Authentication endpoints legitimately return 401 for invalid credentials
    // or expired refresh tokens. Retrying them would recursively call logout.
    if (error.response?.status === 401 && !isAuthRequest && !originalRequest._retry) {
      originalRequest._retry = true;

      const authStore = useAuthStore();
      try {
        await authStore.refreshAccessToken();
        return api(originalRequest);
      } catch {
        await authStore.logout();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);
